import type { ProductKey } from "@merge-api/merge-javascript-shared";
import { fetchWithAuth } from "../../../../../../../api-client/APIClient";
import { User } from "../../../../../../../models/Entities";

interface Params {
  userId: number;
  allowedProducts: ProductKey[];
  onSuccess: (savedUser: User) => void;
  onError: () => void;
}

const changeAllowedProducts = ({ userId, allowedProducts, onSuccess, onError }: Params) =>
  fetchWithAuth({
    path: `/organizations/users/${userId}/allowed-products`,
    method: "PUT",
    body: { allowed_products: allowedProducts },
    onResponse: onSuccess,
    onError,
  });

export default changeAllowedProducts;
